<template>
  <div class="dailylist_box border_box">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="finished_text"
      @load="getReportList"
    >
      <a class="daily_item border_box" v-for="(item,i) of list" :key="i" @click="openReport(item)">
        <div class="report_list_box border_box flex_v_center">
          <div class="content_box">
            <div class="flex_verticle">
              <div class="log_icon wordbox" ></div>
              <div class="info_box">
                <div class="name_box">
                  <div class="name"> {{item.reportFileName}} </div>
                  <div class="btn">
                    <span class="preview" @click="previewWord(item, $event)">预览</span>
                    <span class="download" @click="downloadWord(item, $event)">下载</span>
                  </div>
                </div>
                <div class="date"> 生成时间：{{item.enterTime}} </div>
              </div>
            </div>
          </div>
          <span class="arrow_icon"></span>
        </div>
      </a>
    </van-list>
    <div class="nodata_box border_box" v-show="nodate">无数据</div>
  </div>
</template>
<script>
  import {getReportList as getList, downloadReport} from '@/api/report'
  import { getOpenId } from '@/api/judgment'
  import { List, Toast, Dialog } from 'vant'

  export default {
    name: 'epidemicReportList',
    data() {
      // 根据路由名称判断 reportType
      const routeNameMap = {
        'reportlist1': '1',  // 日报
        'reportlist2': '2',  // 周报
        'reportlist3': '3'   // 月报
      };
      const reportType = routeNameMap[this.$route.name] || '1';

      return {
        params: {
          pageSize: 15,         // 每页条数
          pageNum: 0,           // 页码
          reportType: reportType // 从路由名称判断reportType
        },
        loading: false, // 下拉loading
        finished: false, // 是否加载完毕
        finished_text:"", // 下拉请求完毕展示文字
        nodate:false,  // 无数据判断开关
        list: [],
        total: 0,
      }
    },
    components: { "van-list": List },
    methods: {
      openReport(item) {
        this.$router.push({
          path: '/intelligentReportDetail',
          query: {
            reportId: item.id,
            version: item.version,
            reportType: item.reportType || this.params.reportType,
            openid: this.$store.state.userInfo.openid,
            reportFileName: item.reportFileName,
            enterTime: item.enterTime
          }
        })
      },

      // 初始化 openid
      async initOpenid() {
        // 如果 store 中已有 openid，直接返回
        if (this.$store.state.userInfo.openid) {
          console.log('store 中已有 openid:', this.$store.state.userInfo.openid)
          return
        }

        // 尝试从 URL 参数获取
        const urlOpenid = this.$route.query.openid
        if (urlOpenid) {
          console.log('从 URL 获取 openid:', urlOpenid)
          // 直接修改 state，避免触发 mutation 中的 API 调用
          this.$store.state.userInfo.openid = urlOpenid
          return
        }

        // 尝试从 localStorage 恢复
        const userInfoStr = localStorage.getItem('userInfo')
        if (userInfoStr) {
          try {
            const userInfo = JSON.parse(userInfoStr)
            if (userInfo && userInfo.openid) {
              console.log('从 localStorage 恢复 openid:', userInfo.openid)
              // 直接修改 state
              Object.assign(this.$store.state.userInfo, userInfo)
              return
            }
          } catch (e) {
            console.error('解析 localStorage userInfo 失败:', e)
          }
        }

        // 如果 URL 有 code 参数，调用接口获取 openid
        const code = this.$route.query.code
        if (code) {
          console.log('使用 code 获取 openid:', code)
          try {
            const res = await getOpenId({ code: code, state: this.$route.query.state || '' })
            if (res.data && res.data.openid) {
              console.log('接口返回 openid:', res.data.openid)
              // 直接修改 state，避免触发额外的 API 调用
              Object.assign(this.$store.state.userInfo, res.data)
              localStorage.setItem('userInfo', JSON.stringify(this.$store.state.userInfo))
            }
          } catch (e) {
            console.error('获取 openid 失败:', e)
          }
          return
        }

        console.warn('未能获取到 openid，请确保从微信授权入口访问')
      },

      // 获取列表
      async getReportList() {
        // 确保有 openid
        if (!this.$store.state.userInfo.openid) {
          await this.initOpenid()
        }

        // 如果还是没有 openid，停止加载
        if (!this.$store.state.userInfo.openid) {
          this.loading = false
          this.finished = true
          this.nodate = true
          console.warn('无法获取 openid，停止加载列表')
          return
        }

        this.loading = true;
        this.params.pageNum = parseInt(this.params.pageNum) + 1
        getList(this.params).then(res => {
          if(res.data.code === 200) {
            const total = res.data.data.total
            this.list = [...this.list , ... res.data.data.records]
            this.loading = false

            if(this.list.length === 0) {
              this.nodate = true
            }else if(this.list.length >= total){
              this.finished = true
              this.finished_text = '没有更多了'
            }
            if(res.data.data.records.length < this.params.pageSize){
              this.finished = true
              this.finished_text = '没有更多了'
            }
          }
        })
      },

      // 判断是否为 iOS 系统
      isIOS() {
        const ua = navigator.userAgent
        return /iPhone|iPad|iPod/i.test(ua)
      },

      // 判断是否为 Android 系统
      isAndroid() {
        const ua = navigator.userAgent
        return /Android/i.test(ua)
      },

      // 下载 Word 文档
      async downloadWord(item, event) {
        event.stopPropagation()

        // 判断是否在微信浏览器中
        const isWeiXin = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1

        if (isWeiXin) {
          if (this.isAndroid()) {
            // Android 微信：引导用户在外部浏览器打开下载
            Dialog.alert({
              title: '提示',
              message: '请点击右上角"..."按钮\n选择"在浏览器中打开"\n即可下载文件',
              confirmButtonText: '知道了'
            })
          } else if (this.isIOS()) {
            // iOS 微信：使用现有下载方式
            this.performDownload(item)
          } else {
            // 其他系统：默认引导外部浏览器
            Dialog.alert({
              title: '提示',
              message: '请点击右上角"..."按钮\n选择"在浏览器中打开"\n即可下载文件',
              confirmButtonText: '知道了'
            })
          }
        } else {
          // 普通浏览器：直接下载
          this.performDownload(item)
        }
      },

      // 执行下载操作
      async performDownload(item) {
        Toast.loading({
          message: '下载中...',
          forbidClick: true,
          duration: 0
        })

        try {
          const params = {
            reportId: item.id,
            version: item.version,
            reportType: item.reportType
          }

          const res = await downloadReport(params)
          const blob = res.data

          if (!blob || blob.size === 0) {
            Toast.clear()
            Toast.fail('文件为空')
            return
          }

          // 获取文件名
          let fileName = item.reportFileName || '报告.docx'
          const contentDisposition = res.headers['content-disposition']
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = decodeURIComponent(fileNameMatch[1].replace(/['"]/g, ''))
            }
          }
          if (!fileName.endsWith('.docx')) {
            fileName += '.docx'
          }

          // 下载文件
          const blobUrl = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = blobUrl
          link.download = fileName
          link.style.display = 'none'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          Toast.clear()
          Toast.success('下载成功')

          // 清理 URL
          setTimeout(() => {
            window.URL.revokeObjectURL(blobUrl)
          }, 2000)

        } catch (error) {
          console.error('下载失败:', error)
          Toast.clear()
          Toast.fail('下载失败，请稍后重试')
        }
      },

      // 预览 Word 文档（WPS）
      previewWord(item, event) {
        event.stopPropagation()
        this.$router.push({
          path: '/report',
          query: {
            fileId: item.id,
            openid: this.$store.state.userInfo.openid,
            appkey: 'yqms',
            reportFileName: item.reportFileName,
            enterTime: item.enterTime
          }
        })
      },

      editWord(item){
        console.info(item)
        // 使用实际的文档ID，而不是硬编码的值
        this.$router.push({
          path: '/report',
          query: {
            fileId: item.id ,
            openid: this.$store.state.userInfo.openid ,
            appkey: 'yqms',
            reportFileName:item.reportFileName,
            enterTime: item.enterTime
          }
        });
      }
    },
    mounted() {
      // 动态设置页面标题
      const reportTypeMap = {
        '1': '日报列表',
        '2': '周报列表',
        '3': '月报列表'
      };
      const reportType = this.params.reportType;
      document.title = reportTypeMap[reportType] || '报告列表';
    },
  }
</script>
<style scoped>
  @import url("./reportlist.css");
</style>
